import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  CommissionManage,
  Dashboard, LayoutWrapperMain, Page,
} from '../../components';
import config from '../../config';
import './dashboardpage.global.scss';

interface Props {
  scrollingDisabled: boolean,
  intl: any,
}

const CommissionManagement: React.FC<Props> = (props: Props) => {
  const {
    intl,
    scrollingDisabled,
  } = props;
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: 'Dashboard.page.title' },
    { siteTitle },
  );
  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      <LayoutWrapperMain className="layoutWrapperMain">
        <div className="dashboard_page">
          {/* <Dashboard /> */}
          <CommissionManage />
        </div>
      </LayoutWrapperMain>
    </Page>
  );
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
  // submitSignup: (dispatch: any, data: any) => dispatch(Signup(data)),
});

const CommissionManagementComponentPage = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(CommissionManagement);

export default CommissionManagementComponentPage;
